import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { notificationSubscriptionsCacheKey } from "./constants";

export const getNotificationSubscriptions = reactQueryFetcherAdapter(
  notificationSubscriptionsCacheKey,
  async (signal) => {
    return fetch(notificationSubscriptionsCacheKey, "GET", undefined, { signal });
  }
);
